import { defineMessage } from 'magpie-lib/models';
import * as t from 'ts-schema';

const surveyKeySchema = t.string;

const csatSurveyOpened = defineMessage({
  type: 'csat-survey-opened' as const,
  payloadSchema: t.object({
    surveyKey: surveyKeySchema,
  }),
});

const scheduleCsatSurvey = defineMessage({
  type: 'schedule-csat-survey' as const,
  payloadSchema: t.object({
    surveyKey: surveyKeySchema,
    delay: t.optional(t.number),
  }),
  reply: csatSurveyOpened,
});

const cancelScheduledCsatSurvey = defineMessage({
  type: 'cancel-scheduled-csat-survey' as const,
  payloadSchema: t.object({
    surveyKey: surveyKeySchema,
  }),
});

export const csatControls = {
  scheduleCsatSurvey,
  cancelScheduledCsatSurvey,
  csatSurveyOpened,
} as const;
